import { Loader } from 'components'
import {
  ComponentProps,
  createContext,
  useContext,
  useEffect,
  useState,
} from 'react'
import { useGetTenantByCode } from 'services/tenant'
import { TenantData, TenantDomain } from 'services/tenant/types'
import { handleBrandColors, handleFavicon } from 'shared/hooks/useTenant/utils'
import { useTheme } from 'shared/hooks/useTheme'

const TenantContext = createContext<{
  tenant?: TenantDomain
} | null>(null)

export const TenantProvider = ({
  children,
  ...props
}: ComponentProps<'div'>) => {
  const { theme } = useTheme()

  const [tenant, set] = useState<TenantData | undefined>(undefined)

  const getTenant = () => {
    const hostname = window.location.hostname
    const subdomain = hostname.split('.')[0]

    //TODO: Remove tenant redirection when the correct domain exists.
    if (subdomain === 'ubisafe') return 'orsegups'

    return 'orsegups'
  }

  const { data, isLoading } = useGetTenantByCode(getTenant())

  useEffect(() => {
    if (!tenant && data) {
      set(data)

      sessionStorage.setItem('tenantId', data.id)
      sessionStorage.setItem('tenantCode', data.code)

      document.documentElement.setAttribute('tenant', data.code)

      const { lightTheme, darkTheme } = data.brand

      handleBrandColors({ light: lightTheme.color, dark: darkTheme.color })

      handleFavicon(
        theme === 'dark' ? darkTheme.images.logo : lightTheme.images.logo,
      )
    }
  }, [data])

  return (
    <TenantContext.Provider
      value={{
        ...(tenant && {
          tenant: {
            ...tenant,
            brand:
              tenant?.brand?.[theme === 'dark' ? 'darkTheme' : 'lightTheme'],
          },
        }),
      }}
      {...props}
    >
      {isLoading ? <Loader appearance="screen" /> : children}
    </TenantContext.Provider>
  )
}

export const useTenant = () => {
  const context = useContext(TenantContext)

  if (!context) throw new Error('useTenant must be used within TenantProvider')

  return context
}
